import {isValidUPN} from '../../../../utility/validationUtil';

export const basicInfoFields = {
    studentInfo: [
        {
            id: 'profile_forename',
            title: 'Forename',
            key: 'forename',
            type: 'textField',
            isRequired: false,
            maxLength: 60,
            parentEdit: true
        },
        {
            id: 'profile_middleName',
            title: 'Middle Name',
            key: 'middleName',
            type: 'textField',
            isRequired: false,
            maxLength: 60,
            parentEdit: true
        },
        {
            id: 'profile_surname',
            title: 'Surname',
            key: 'legalSurname',
            type: 'textField',
            isRequired: true,
            maxLength: 60,
            parentEdit: true
        },
        {
            id: 'profile_preferredForename',
            title: 'Preferred Forename',
            key: 'chosenName',
            type: 'textField',
            isRequired: false,
            maxLength: 60,
            parentEdit: true
        },
        {
            id: 'profile_preferredSurname',
            title: 'Preferred Surname',
            key: 'surname',
            type: 'textField',
            isRequired: false,
            maxLength: 60,
            parentEdit: true
        },
        {
            id: 'profile_dateOfBirth',
            title: 'Date Of Birth',
            key: 'dateOfBirth',
            type: 'datePicker',
            isRequired: false,
            maxLength: 60,
            parentEdit: true,
            minDate: new Date('1970-01-01'),
        },
        {
            id: 'profile_email',
            title: 'Email',
            key: 'email',
            type: 'textField',
            isRequired: false,
            maxLength: 60,
            parentEdit: false,
            regex: /^[a-zA-Z0-9-.+]+@([a-zA-Z0-9-]+.)+[a-zA-Z]{2,4}$/
        },
    ],
    educationInfo: [
        {
            id: 'profile_form',
            title: 'Form',
            key: 'formId',
            type: 'select',
            isRequired: false,
            parentEdit: false
        },
        {
            id: 'profile_house',
            title: 'House',
            key: 'houseId',
            type: 'select',
            isRequired: false,
            parentEdit: false
        },
        {
            id: 'profile_boarderStatus',
            title: 'Boarder Status',
            key: 'boarderId',
            type: 'select',
            isRequired: false,
            parentEdit: false
        },
        {
            id: 'profile_upn',
            title: 'UPN',
            key: 'upn',
            type: 'textField',
            isRequired: false,
            parentEdit: false,
            validate: (value) => isValidUPN(value),
            validationErrorMessage: 'UPN\'s must use the format Annnnnnnnnnnn. The letters I,O and S are not allowed. Temporary UPN\'s have a trailing letter.'
        }
    ],
    addressFirstSection: [
        {
            id: 'profile_apartment',
            title: 'Apartment',
            key: 'apartment',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_houseNumber',
            title: 'House Number',
            key: 'houseNumber',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_street',
            title: 'Street',
            key: 'street',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_district',
            title: 'District',
            key: 'district',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_town',
            title: 'Town',
            key: 'town',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
    ],
    addressSecondSection: [
        {
            id: 'profile_houseName',
            title: 'House Name',
            key: 'houseName',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_county',
            title: 'County',
            key: 'county',
            type: 'textField',
            isRequired: false,
            maxLength: 40,
            parentEdit: true
        },
        {
            id: 'profile_postcode',
            title: 'Postcode',
            key: 'postcode',
            type: 'textField',
            isRequired: false,
            maxLength: 8,
            parentEdit: true
        },
        {
            id: 'profile_country',
            title: 'Country',
            key: 'countryCode',
            type: 'select',
            isRequired: false,
            parentEdit: true
        }
    ]
}
